export const spamScoreVariant = score => {
  if (score >= 0 && score <= 30) return 'success';
  if (score >= 31 && score <= 60) return 'warning';
  if (score >= 61) return 'danger';
};
